import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createPortal } from "react-dom";
import { Icon } from "@jti/ui";
import Close from "@jti/ui/icons/close.svg";
import "./PrivacyFormDialog.scss";
const PrivacyFormDialog = ({ isOpened, onClose, title, description }) => {
    if (!isOpened) {
        return null;
    }
    return createPortal(_jsx("div", { "data-testid": "privacyFormDialog", className: "privacy-form-dialog", children: _jsxs("div", { className: "privacy-form-dialog__content", children: [_jsx("div", { className: "privacy-form-dialog__close-btn", children: _jsx(Icon, { component: Close, className: "language-selector__popup-mobile-close-btn", width: "16px", height: "16px", dataTestId: "languageSelectorCloseBtn", onClick: onClose }) }), _jsx("div", { className: "privacy-form-dialog__title", children: title }), _jsx("p", { className: "privacy-form-dialog__description", children: description })] }) }), document.body);
};
export default PrivacyFormDialog;
//# sourceMappingURL=PrivacyFormDialog.js.map